import { Grid } from 'components/grid'
import { defineComponent } from 'vue'
import type { IBaseComponentProps } from 'components/base/types'
import type { FindexInvestment, FullInvestment, IntegrationProvider, IProviderImport } from 'findef'

export const LockedByProviderTooltip = defineComponent<IBaseComponentProps & {
  providerImport: Omit<IProviderImport, 'provider'> & { provider: IntegrationProvider };
  investment: FindexInvestment | FullInvestment;
  onClickReconnect?: () => void | Promise<void>;
}>({
  setup(props) {
    // const isConnected = computed(() => !!props.providerImport.session.connected)
    // const badgeVariant = computed(() => (isConnected.value ? 'blue' : 'error'))
    // const badgeText = computed(() => (isConnected.value ? 'Connected' : 'Session Expired'));
    // const dateConnected = computed(() => props.providerImport.lastSync);
    // const dateConnectedStr = computed(() => dateConnected.value ? dateFmt(dateConnected.value, 2) : 'never');
    // const bankAccount = computed(() => props.providerImport.available.bankAccounts.find(it => !!it.investments.find(inv => inv.externalId === props.investment.externalId)));
    // const bankAccountName = computed(() => bankAccount.value ? bankAccount.value.name : '?');

    return () => {
      return (
        <div class="min-w-[16rem]">
          <Grid
            columns="max-content auto"
            class="h-16 p-3 bg-primary-100 justify-start items-start gap-2"
            alignItems="center"
          >
            <div class="bg-white border border-gray-300 justify-center items-center inline-flex">
              <img
                style={{
                  width: '40px',
                  height: '40px',
                  aspectRatio: '1 / 1',
                  objectFit: 'contain'
                }}
                src={props.providerImport.provider.iconUrl}
              />
            </div>
            <Grid noDefaultLayout rows="max-content max-content" alignItems="center">
              <div class="text-primary-500 text-xs font-semibold font-['Inter'] leading-[18px]">
                {props.providerImport.provider.displayName || props.providerImport.provider.name}
              </div>
              <div class="text-gray-500 text-xs font-normal font-['Inter'] leading-[18px]">
                Bank Provider
              </div>
            </Grid>
          </Grid>
          <div class="divide-y divide-gray-200">
            <Grid class="p-3 bg-white" columns="max-content" justifyContent="center" alignItems="center">
              <div
                class="text-gray-900 text-xs font-medium font-['Inter'] leading-3"
              >
                This field is maintained by a provider
              </div>
            </Grid>
          </div>
        </div>
      )
    }
  }
})

LockedByProviderTooltip.props = ['providerImport', 'onClickReconnect', 'investment']
